import {
  candidate_base_url,
  recruiter_base_url,
  user_base_url
} from "@/store/urls/base_urls";

export const GET_UNIQUE_SECTORS = user_base_url + "sectors/";
export const GET_ROLES_LIST = user_base_url + "roles/list/";

export const GET_JOB_BY_ID = user_base_url + "job-details/";

export const FETCH_SKILLS_GROUP = user_base_url + "skill-groups/";
export const FETCH_SKILLS = user_base_url + "skills/";

export const FETCH_USER_WITH_PROFILE = user_base_url + "user-profile/";

export const FETCH_NOTIFICATIONS_COUNT = user_base_url + "notifications/count/";
export const FETCH_NOTIFICATIONS = user_base_url + "notifications/list/";

export const NOTIFICATIONS_ACTION = user_base_url + "notifications/seen/";

export const FETCH_USERS_INFO = candidate_base_url + "autocomplete/name?input=";

export const FETCH_ASSESSMENT_SUMMARY =
  candidate_base_url + "/principles/assessments/summary/";
export const FETCH_ASSESSMENT_PDF =
  candidate_base_url + "/principles/assessments/pdf/";

export const FETCH_ASSESSMENT =
  candidate_base_url + "/principles/assessments/user/";

export const APP_ASSESSMENTS = recruiter_base_url + "assessments/";

export const APP_ASSESSMENTS_RESULTS = recruiter_base_url + "assessments/";
export const MARK_ASSESSMENT_RESUMED = (assessment_id: number): string =>
  recruiter_base_url + `assessments/${assessment_id}/mark-resumed`;
export const REVERT_ASSESSMENT_TO_IN_PROGRESS = (
  assessment_id: number
): string =>
  recruiter_base_url + `assessments/${assessment_id}/revert-to-in-progress`;
export const SAVE_ASSESSMENT_STATE = (assessment_id: number): string =>
  recruiter_base_url + `assessments/${assessment_id}/save-state`;
export const REDO_ASSESSMENTS_REQUEST = recruiter_base_url + "assessments/";

export const REQUEST_ASSESSMENT_RESUME = (assessment_id: number): string =>
  recruiter_base_url + `assessments/${assessment_id}/request-resume`;

export const CANCEL_MY_ASSESSMENT_ATTEMPT = (assessment_id: number): string =>
  recruiter_base_url + `assessments/${assessment_id}/cancel-my-attempt`;

export const APPROVE_ASSESSMENT_RESUME = (result_id: number): string =>
  recruiter_base_url + `assessments/results/${result_id}/resume-approve`;

export const REJECT_ASSESSMENT_RESUME = (result_id: number): string =>
  recruiter_base_url + `assessments/results/${result_id}/resume-reject`;

export const SEND_EMAIL = user_base_url + "send-email/";

export const UPLOAD_FILE_CHUNK = user_base_url + "upload-file-chunk/";

export const FETCH_USERS_WITH_NAME_AND_EID =
  candidate_base_url + "autocomplete/name?";
